module.exports = __webpack_public_path__ + "static/media/SourceSansPro-It.b0151e1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-It.svg
// module id = 339
// module chunks = 3